<template>
  <div>
    <base-nav
      class="navbar-top navbar-horizontal navbar-light"
      containerClasses="px-4 container-fluid "
      expand>
      <router-link slot="brand" class="navbar-brand" to="/">
        <img src="img/brand/logo.png" />
        <!-- <span class="small mb-0 align-bottom">V.{{popVersion}}</span> -->
      </router-link>
      <template v-slot="{ closeMenu }">
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img src="img/brand/logo.png" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <button
                type="button"
                @click="closeMenu"
                class="navbar-toggler"
                aria-label="Toggle sidenav">
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item d-flex align-self-center">
            <base-dropdown class="pr-0 dropdown-menu-pos">
              <div class="media align-items-center mb-0" slot="title">
                <div class="media-body ml-2 d-none d-md-block d-lg-block px-1">
                  <span class="mb-0 text-sm font-weight-bold">
                    {{ userLogin.name }}
                    <br />
                  </span>
                  <!-- <p class="mb-0 small">{{ userLogin.role }}</p> -->
                </div>
                <span class="b-avatar badge-primary rounded-circle">
                  <span class="b-avatar-text">
                    <span>{{ firstTitleName }}</span>
                  </span>
                </span>
                <i class="fas fa-caret-down pl-2"></i>
              </div>
              <template>
                <!-- <div class="dropdown-header noti-title dropdown-menu-left">
                  <a
                    class="dropdown-item p-0"
                    :class="visibleShopDetails ? null : 'collapsed'"
                    :aria-expanded="visibleShopDetails ? 'true' : 'false'"
                    aria-controls="collapse-shop-detail"
                    @mouseover="visibleShopDetails = true"
                    @mouseleave="visibleShopDetails = false">
                    <div class="row">
                      <div class="col-12 col-lg-8 col-xl-8 col-md-8">
                        <template v-if="userLogin.role == 'admin'">
                          <h4>{{ userLogin.shop_name }}</h4>
                          <h6>{{ userLogin.email }}</h6>
                        </template>
                        <template v-else>
                          <h4 class="pt-3">{{ userLogin.email }}</h4>
                        </template>
                      </div>
                      <div class="col-12 col-lg-4 col-xl-4 col-md-4">
                        <i
                          class="fas fa-angle-right fa-lg pt-4 pl-5"
                          v-if="!visibleShopDetails"></i>
                        <i class="fas fa-angle-down fa-lg pt-4 pl-5" v-else></i>
                      </div>
                    </div>
                  </a>
                </div> -->
                <b-collapse
                  id="collapse-shop-detail"
                  v-model="visibleShopDetails"
                  class="mt-2">
                  <div class="dropdown-divider"></div>
                  <!-- <BaseShopDetails></BaseShopDetails> -->
                </b-collapse>
                <div class="dropdown-divider"></div>
                <router-link to="/logout" class="dropdown-item">
                  <i class="fas fa-sign-out-alt text-color-wallet"></i>
                  <span class="text-color-wallet">ออกจากระบบ</span>
                </router-link>
              </template>
            </base-dropdown>
          </li>
        </ul>
      </template>
    </base-nav>
  </div>
</template>

<script>
import BaseShopDetails from "@/components/BaseShopDetails";
import NotificationBell from "@/components/NotificationPlugin/NotificationBell";
import DropDownShop from "@/components/custom/DropDownShop";
import DropDownWallet from "@/components/custom/DropDownWallet";
import { getCookie } from "../../../helpers/util.js";
export default {
  name: "NavbarPos",
  props: {
    userLogin: [Object, Array],
    customTheme: Object,
    shopSetting: Object,
  },
  components: {
    BaseShopDetails,
    NotificationBell,
    DropDownShop,
    DropDownWallet,
  },
  mounted() {
    this.getNotify();
  },
  data() {
    return {
      popVersion: process.env.VUE_APP_VERSION,
      dataNotify: [],
      isload: false,
      paginate: {
        page: 1,
        totalPage: 0,
      },
      newMessage: false,
      visibleShopDetails: false,
    };
  },
  methods: {
    setNewMessage(status) {
      this.newMessage = status;
    },
    async getNotify() {
      this.isload = true;
      await this.$http
        .get(this.$API_URL + "/notify", {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
          params: {
            page: this.paginate.page,
          },
        })
        .then((res) => {
          let data = res.data.data;
          this.dataNotify = [...this.dataNotify, ...data.data];

          if (
            this.dataNotify.length &&
            (!getCookie("read_noti") ||
              this.moment(this.dataNotify[0].created_at).valueOf() >
                getCookie("read_noti"))
          ) {
            this.setNewMessage(true);
          } else {
            this.setNewMessage(false);
          }
          this.paginate.page = data.page;
          this.paginate.totalPage = data.total_page;
        });
      this.isload = false;
    },
  },
  computed: {
    firstTitleName() {
      return this.$USER_LOGIN.get().details.name.slice(0, 1).toUpperCase();
    },
  },
};
</script>
